import { collect } from 'collect.js';

/**
 * Foodamigos' own restaurants are created with only the owner's login (PROD-557): the legal and
 * personal details are entered in Get Started, so nothing sales or Google filled in reaches the
 * payment providers. Partners keep the full form (Nishita).
 */
export const leavesLegalDetailsToOwner = (serviceProvider) => Boolean(serviceProvider?.is_master);

/**
 * Get Started's German steps ask for the legal form, which sets the business type, so a German
 * restaurant is not asked it here as well (PROD-836). Those steps run on the restaurant's own
 * country and nowhere else, so the type is still asked here unless every restaurant created is in
 * Germany: anywhere else this is the only place it is set, and a company would otherwise count as
 * a sole trader on its contract, its invoices and at Adyen.
 */
export const getsBusinessTypeInGetStarted = (companies) =>
  companies?.length > 0 && companies.every((company) => company?.country === 'DE');

const OWNER_LOGIN_FIELDS = ['owner_email', 'password'];

const FULL_FORM_REQUIRED_FIELDS = [
  ...OWNER_LOGIN_FIELDS,
  'business_type',
  'display_name',
  'legal_name',
  'legal_address',
  'legal_city',
  'legal_state',
  'legal_country',
  'legal_zip_code',
  'owner_phone_number',
];

const requiredFields = (serviceProvider, companies) => {
  if (!leavesLegalDetailsToOwner(serviceProvider)) {
    return FULL_FORM_REQUIRED_FIELDS;
  }

  return getsBusinessTypeInGetStarted(companies) ? OWNER_LOGIN_FIELDS : ['business_type', ...OWNER_LOGIN_FIELDS];
};

export const isNewBusinessProfileComplete = (profile, serviceProvider, companies) =>
  requiredFields(serviceProvider, companies).every((field) => Boolean(profile?.[field]));

/** Only what the form asked for is sent, so a value it no longer shows cannot slip through. */
export const newBusinessProfilePayload = (profile, serviceProvider, companies) =>
  leavesLegalDetailsToOwner(serviceProvider)
    ? collect(profile).only(requiredFields(serviceProvider, companies)).all()
    : profile;
